var WORKER_URL = 'https://vat-validator.sweet-queen-c951.workers.dev/';

var vatCodes = {
  AT:'VAT-AT',BE:'VAT-BE',BG:'VAT-BG',CY:'VAT-CY',CZ:'VAT-CZ',
  DE:'VAT-DE',DK:'VAT-DK',EE:'VAT-EE',ES:'VAT-ES',FI:'VAT-FI',
  FR:'VAT-FR',GR:'VAT-GR',HR:'VAT-HR',HU:'VAT-HU',IE:'VAT-IE',
  IT:'VAT-IT',LT:'VAT-LT',LU:'VAT-LU',LV:'VAT-LV',MT:'VAT-MT',
  NL:'VAT-NL',PL:'VAT-PL',RO:'VAT-RO',SE:'VAT-SE',SI:'VAT-SI',SK:'VAT-SK'
};

function setupVat() {
  var btn = document.getElementById('vat-apply-btn');
  var input = document.getElementById('vat-number-input');
  var status = document.getElementById('vat-status');

  if (!btn || !input || !status || btn._vatReady) return;
  btn._vatReady = true;

  function setStatus(text, color, bg) {
    status.textContent = text;
    status.style.color = color;
    status.style.background = bg;
    status.style.display = 'block';
  }

  function setLoading(loading) {
    btn.disabled = loading;
    btn.textContent = loading ? 'Checking...' : 'Apply';
    btn.style.opacity = loading ? '0.6' : '1';
  }

  btn.addEventListener('click', function() {
    var val = input.value.trim().toUpperCase();

    if (val.length < 4) {
      setStatus('⚠ Please enter a valid VAT number.', '#856404', '#fff3cd');
      return;
    }

    var prefix = val.substring(0, 2);
    var discountCode = vatCodes[prefix];

    if (!discountCode) {
      setStatus('⚠ Prefix not recognized as an EU country.', '#856404', '#fff3cd');
      return;
    }

    setLoading(true);
    setStatus('⏳ Validating VAT number with VIES...', '#0c5460', '#d1ecf1');

    fetch(WORKER_URL + '?vat=' + encodeURIComponent(val))
      .then(function(r) { return r.json(); })
      .then(function(data) {
        setLoading(false);
        if (data.valid === true) {
          setStatus('✓ VAT valid — redirecting to apply exemption...', '#155724', '#d4edda');
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ note: 'VAT Number: ' + val })
          }).finally(function() {
            window.location.href = '/discount/' + discountCode + '?redirect=/cart';
          });
        } else if (data.error === 'VIES unavailable') {
          setStatus('⚠ Validation service unavailable. Please contact us for manual exemption.', '#856404', '#fff3cd');
        } else {
          setStatus('✗ VAT number not found in VIES. Please check and try again.', '#721c24', '#f8d7da');
        }
      })
      .catch(function() {
        setLoading(false);
        setStatus('⚠ Validation service unavailable. Please contact us for manual exemption.', '#856404', '#fff3cd');
      });
  });
}

setupVat();

if (!window._vatObserver) {
  window._vatObserver = new MutationObserver(function() {
    setupVat();
  });
  window._vatObserver.observe(document.body, { childList: true, subtree: true });
}
